import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerGovIdBadgeComponent } from './customer-gov-id-badge.component';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [CustomerGovIdBadgeComponent],
  exports: [CustomerGovIdBadgeComponent],
  imports: [CommonModule, MatIconModule, RouterModule, RouterModule],
})
export class CustomerGovIdBadgeModule {}
